import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {UserService} from '../../../services/user.service';
import {LoginService} from '../../../services/login.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  @Output() showForgotPassword: EventEmitter<{show: boolean, email: string}> = new EventEmitter();
  @Input() email: string;

  forgotForm: FormGroup;

  emailSent: boolean = false;

  constructor(private userService: UserService, private loginService: LoginService, private fb: FormBuilder) {
    this.forgotForm = this.fb.group({
      email: ['', Validators.required]
    });
   }

  ngOnInit() {
    if (this.email) this.forgotForm.setValue({email: this.email});

  }

  onSubmit() {
    this.loginService.sendForgotPasswordEmail(this.forgotForm.get('email').value).then(response => {
      this.emailSent = true;
    });
  }

  get forgotEmail() {
    return this.forgotForm.get('email');
  }

  set forgotEmail(val) {
    this.forgotForm.get('email').setValue(val);
  }
}
